<template>
  <div class="slo-tag-filter">
    <label v-html="label" class="text-base fw-strong sm:mt-sm sm:mr-md"></label>
    <ais-refinement-list
      operator="and"
      :attribute="_attribute"
      :transformItems="transformItems"
      :limit="999"
    >
      <template v-slot="{ items, refine }">
        <div class="flex flex-wrap filter-values">
          <div class="flex-row flex-wrap" v-for="item in items" :key="item.value">
            <span
              class="filter-value-wrapper"
              v-if="item.isRefined || item.count !== totalCount"
            >
              <span
                class="filter-value flex items-start"
                :class="{ active: item.isRefined }"
                @click="refine(item.value)"
              >
                <SloIcon v-if="item.isRefined" name="XMark" class="mr-2xs mt-xs" />
                <span>{{ item.label }}</span>
              </span>
            </span>
          </div>
        </div>
      </template>
    </ais-refinement-list>
  </div>
</template>

<script>
import {transformItems} from '../product-configurator/filters-config';
import SloIcon from '../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: {
    label: {type: String, required: true},
    totalCount: {type: Number},
    filter: {type: Object},
    attribute: {type: String}
  },
  computed: {
    _attribute() {
      if (this.attribute) return this.attribute;

      if (this.filter) return this.filter.id;
    }
  },
  methods: {
    transformItems(items) {
      if (!this.filter) return items.sort((a, b) => a.label.localeCompare(b.label));
      return transformItems(this.filter, items);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/system';

.filter-values {
  margin: 0 -5px;
}

.filter-value-wrapper {
  border: 4px solid transparent;
}

.filter-value {
  padding: 4px 8px;
  border-radius: 4px;
  background: $color-gray-100;
  cursor: pointer;

  &:hover,
  &:focus {
    background: $color-gray-300;
  }

  &:active,
  &.active {
    background: $color-gray-700;
    color: $color-white;
    font-weight: 500;
  }
}
</style>
